import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageBodyPanelComponent } from 'src/app/shared/page-body-panel/page-body-panel.component';
import { ListModuleToolbarComponent } from './list-module-toolbar.component';
import { ListModulePaginationComponent } from './list-module-pagination.component';
import {
  ListModuleFilters,
  ListModulePaginationMeta,
  ListModuleSurfaceConfig,
  ListModuleToolbarConfig,
  DEFAULT_LIST_MODULE_FILTERS,
  listModulePaginationEnabled,
  listModuleFilterEnabled,
} from './list-module.types';

@Component({
  selector: 'app-list-module-surface',
  standalone: true,
  imports: [
    CommonModule,
    PageBodyPanelComponent,
    ListModuleToolbarComponent,
    ListModulePaginationComponent,
  ],
  templateUrl: './list-module-surface.component.html',
})
export class ListModuleSurfaceComponent {
  private static readonly emptyToolbar: ListModuleToolbarConfig = {};

  /** Enable/disable toolbar filters and pagination per page. */
  @Input() config: ListModuleSurfaceConfig = {
    toolbar: { search: true, status: true, dateRange: true },
    pagination: true,
  };

  @Input() filters: ListModuleFilters = { ...DEFAULT_LIST_MODULE_FILTERS };
  @Input() deletedView = false;

  @Input() errorMessage = '';
  @Input() loading = false;
  @Input() meta: ListModulePaginationMeta | null = null;
  @Input() rowCount = 0;

  @Output() filtersChange = new EventEmitter<Partial<ListModuleFilters>>();
  @Output() pageChange = new EventEmitter<number>();

  get toolbarConfig() {
    return this.config.toolbar ?? ListModuleSurfaceComponent.emptyToolbar;
  }

  get showBuiltinToolbar(): boolean {
    const t = this.toolbarConfig;
    return (
      listModuleFilterEnabled(t.search) ||
      listModuleFilterEnabled(t.status) ||
      listModuleFilterEnabled(t.dateRange)
    );
  }

  get showPagination(): boolean {
    return listModulePaginationEnabled(this.config.pagination);
  }

  onFiltersChange(patch: Partial<ListModuleFilters>): void {
    this.filtersChange.emit(patch);
  }
}
